import { MjmlButton, MjmlColumn, MjmlSection } from "@faire/mjml-react";
import { chunk } from "lodash-es";
import { makePollUrl } from "../../../make-poll-url";

import type { PollButtonProps } from "../types";
import type { FC } from "react";

export const HorizontalPollButtons: FC<PollButtonProps> = ({
  buttonType,
  options,
  align,
  account_id,
  buttonWidth,
  paperSize,
}) => {
  // Split the options into the number of needed rows based on the paper size
  const buttonsPerRow = Math.floor((paperSize - 50) / buttonWidth);
  const buttonRows = chunk(options, buttonsPerRow);

  return (
    <>
      {buttonRows.map((row, index) => (
        <MjmlSection key={index} mjmlClass="section">
          {row.map((option) => (
            <MjmlColumn key={option.id}>
              <MjmlButton
                key={option.id}
                mjmlClass={buttonType}
                href={makePollUrl(account_id, option.id)}
                align={align}
                width={`${buttonWidth}px`}
              >
                {option.text}
              </MjmlButton>
            </MjmlColumn>
          ))}
          {row.length < buttonsPerRow &&
            Array.from({ length: buttonsPerRow - row.length }).map((_, i) => (
              <MjmlColumn key={`extra-column-${i}`} />
            ))}
        </MjmlSection>
      ))}
    </>
  );
};
